import { VOWELS } from "@/constants";

const formatLabel = (
  str: string,
  formattingFunction?: (value: number | string) => React.ReactNode,
  ...values: Array<number | string>
) => {
  const templateSplit = new RegExp(/{(\d)}/g);
  const isNumber = new RegExp(/^\d+$/);
  const splittedText = str.split(templateSplit);
  return splittedText.map((sentence) => {
    if (isNumber.test(sentence)) {
      const value = values[Number(sentence)];
      return formattingFunction ? formattingFunction(value) : value;
    }
    return sentence;
  });
};

const formatWordWithIndefiniteArticles = (word: string) => {
  if (word === "hour" || VOWELS.has(word[0]) || word[0] === "8") {
    return `an ${word}`;
  }

  return `a ${word}`;
};

export { formatLabel, formatWordWithIndefiniteArticles };
